import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { MonthviewStyle } from './monthview.style';
import { ILocalEvent } from '@app-types/websocket/event.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof MonthviewStyle> {
  shape:React.CSSProperties; // width, margin and corners from the row layout
  hide?:boolean;
  event:ILocalEvent;
  style?:React.CSSProperties;
}

interface IState {
  someValue: number;
}

class DayImportedEvent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      someValue: 1,
    };

  }

  public render() {
    const {classes, shape, event} = this.props;
    const background:string = "#c3c3c3"+"d6";

    let opacity:number = 1;

    if (this.props.hide) {
      opacity = 0;
    }
    const finalStyle:React.CSSProperties= { ...this.props.style, background, ...shape, opacity };

    return (
      <div className={classes.event} style={finalStyle}>
        {event.title}
      </div>
    );
  }


}

export default withStyles(MonthviewStyle)(DayImportedEvent);



// WEBPACK FOOTER //
// ./src/components/calendar2/monthView/DayImportedEvent.tsx